import type { BID_REQUEST_DECLINED_REASON } from '#@/__gql__/graphql';

export interface PremiumPageQueryParams {
  status?: 'success';
  subcontractorId?: string;
}

export interface BidRequestQueryParams {
  showSignupSuggestion?: boolean;
  showDocuments?: boolean;
  openMessages?: boolean;
  threadId?: string;
}

export interface BidInviteQueryParams {
  invitePaywallViewTender?: true;
  reminderPaywallViewTender?: true;
  trackViewDetailsAndDocuments?: true;
  trackShowMore?: true;
  haveQuestionsPosition?: string;
}

export enum ProjectOverviewFocusFieldsQueryParams {
  budget = 'budget',
}

export enum BidPackageOverviewFocusFieldsQueryParams {
  description = 'description',
  name = 'name',
  bidsDueDate = 'bidsDueDate',
  startsOn = 'startsOn',
  endsOn = 'endsOn',
  users = 'users',
  awardingDate = 'awardingDate',
  isPublishedOnMarketplace = 'isPublishedOnMarketplace',
}

export interface AgentUnsolicitedSignupQueryParams {
  origin?: 'website' | 'openIndex';
  version?: 'premium';
  redirect?: string;
  subcontractorId?: string;
  subcontractorName?: string;
  hasProfileChanged?: string;
}

export interface AgentUnauthenticatedMarketplaceSamplesQueryParams {
  sentEmailId?: string;
  declinedReason?: BID_REQUEST_DECLINED_REASON;
  hasProfileChanged?: boolean;
  subcontractorId: string | undefined;
  subcontractorName: string | undefined;
}

export interface LoginPageQueryParams {
  redirect?: string;
  errorCode?: string;
  redirectToPremium?: boolean;
  stage?: 'resetPassword' | 'sso' | 'individualPricing';
  signupId?: string;
  agentContext?:
    | {
        subcontractor: {
          agentCompanyId?: string | null;
          city: string | null;
          id: string;
          isClaimedByAgentCompany: boolean;
          name: string;
          postalCode: null | string;
        };
      }
    | string;
}

export interface SubcontractorBidQueryParams {
  showCompleteProfilePrompt?: boolean;
  showUpdateWorkCategories?: boolean;
  showMarketplaceSuggestions?: boolean;
  trackBidConfirmationViewBid?: boolean;
}

export interface BidInviteFeedbackQueryParams {
  sentEmailId?: string;
  subcontractorId?: string;
  withoutReason?: true;
  invitePaywallDecline?: true;
  reminderPaywallDecline?: true;
}
